import React from "react";
import { NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

var bgimg3 = require("../../images/video-img.jpg");

class SimilarProjects extends React.Component {
  render() {
    return (
      <>
        <div className="section-full p-tb40 bg-white inner-page-padding">
          <div className="container-fluid">
            <div className="section-content">
              {/* TITLE START */}
              <div className="section-head">
                <div className="sx-separator-outer separator-center">
                  <div
                    className="sx-separator bg-white"
                    // style={{ backgroundImage: "url(" + bgimg2 + ")" }}
                  >
                    <h3 className="bg-white sep-line-one">
                      {" "}
                      Vidéo de notre projet
                    </h3>
                  </div>
                </div>
              </div>
              {/* TITLE END */}
              <div className="work-carousel-outer">
                <div className="mfp-gallery project-carousel project-carousel1 owl-btn-vertical-center">
                  <div className="item">
                    <div
                      className="sx-box   image-single-carousel bg-cover"
                      style={{ backgroundImage: "url(" + bgimg3 + ")" }}
                    >
                      <div className="overlay-main bg-black opacity-05" />
                      <div className="p-t20 text-white">
                        <div className="video-section-content">
                          <NavLink
                            to={"#"}
                            className="play-now"
                            data-toggle="modal"
                            data-target="#myModal"
                          >
                            <i className="icon fa fa-play" />
                            <span className="ripple" />
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SimilarProjects;
